export function supportPhone(value) {
  if (typeof value !== 'string' || value.length > 250) return '';
  let text = value.trim();
  if (text.startsWith('https://')) {
    if (!/^https:\/\/(wa\.me|api\.whatsapp\.com)\//.test(text)) return '';
    try {
      const url = new URL(text);
      if (url.username || url.password || url.port || url.hash) return '';
      if (url.hostname === 'wa.me') text = url.pathname.replace(/^\/+|\/+$/g, '');
      else if (url.hostname === 'api.whatsapp.com' && url.pathname === '/send') text = url.searchParams.get('phone') || '';
      else return '';
    } catch { return ''; }
  }
  if (!/^[+0-9() .-]+$/.test(text)) return '';
  let digits = text.replace(/[^0-9]/g, '');
  if ([10, 11].includes(digits.length) && !text.startsWith('+')) digits = `55${digits}`;
  return /^[1-9][0-9]{9,14}$/.test(digits) ? digits : '';
}
export function connectionSupportPhone(connection) {
  return supportPhone(connection?.phone_connected) || supportPhone(connection?.phone_number);
}
export function supportContacts(settings = {}) {
  const rows = settings.support_contacts !== undefined
    ? (Array.isArray(settings.support_contacts) ? settings.support_contacts : [])
    : [{ id: 'manual', label: settings.support_label || 'Suporte', phone: settings.support_whatsapp }];
  const seen = new Set();
  return rows.slice(0, 51).flatMap(row => {
    const phone = supportPhone(row?.phone);
    if (!phone || seen.has(phone)) return [];
    seen.add(phone);
    return [{ id: String(row.id || 'manual').slice(0, 100), label: String(row.label || 'Suporte').slice(0, 100), phone }];
  });
}
export const supportHref = contact => {
  const phone = supportPhone(contact?.phone);
  return phone ? `https://wa.me/${phone}` : '';
};
